// TODO: [zhbliu] merge view and control
import numberField from '@bingads-webui-component-legacy/form/view/field/number';

export default numberField;
